import { useEffect, useState } from 'react';
import { SegTextarea } from '../../../../../Components/SegUI/SegTextArea/SegTextArea';
import { SegButton } from '../../../../../Components/SegUI/SegButton/SegButton';
import { StepComponentProps } from '../../Siniestros';
import { useSiniestroStore } from '../../../../../Services/Providers/SiniestroStore';
import { Controller, FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { SegInput } from '../../../../../Components/SegUI/SegInput/SegInput';
import { SegTooltip } from '../../../../../Components/SegUI/SegTooltip/SegTooltip';
import { SegSelect, SegSelectOption } from '../../../../../Components/SegUI/SegSelect/SegSelect';
import { useNavigate } from 'react-router-dom';
import SingleImageUpload from '../../../../../Components/otros/SingleImageUpload';

export const AccidenteTransitoDetalle = ({ setSteps, config }: StepComponentProps) => {

    const { siniestroValues, setSiniestroValues } = useSiniestroStore();
    const methods = useForm({
        defaultValues: {
            numDoc: siniestroValues.dni ? siniestroValues.dni : "",
            tieneDanios: false,
            relatoHechos: siniestroValues.relatoHechos ? siniestroValues.relatoHechos : '',
            daniosVehiculo: siniestroValues.daniosVehiculo ? siniestroValues.daniosVehiculo : '',
            image1: siniestroValues.archivos ? siniestroValues.archivos[0] : null,
            image2: siniestroValues.archivos ? siniestroValues.archivos[1] : null,
            image3: siniestroValues.archivos ? siniestroValues.archivos[2] : null,
            registro1: siniestroValues.documentacion ? siniestroValues.documentacion[0] : null,
            registro2: siniestroValues.documentacion ? siniestroValues.documentacion[1] : null,
            cedula1: siniestroValues.documentacion ? siniestroValues.documentacion[2] : null,
            cedula2: siniestroValues.documentacion ? siniestroValues.documentacion[3] : null,
        }
    });
    const { formState, handleSubmit, control, setValue, trigger, watch, clearErrors, setError } = methods;
    const [tieneDanios, setTienedanio] = useState<SegSelectOption>({ label: "No", value: "false" });
    const nav = useNavigate();
    const tieneDaniosForm = watch("tieneDanios");


    useEffect(() => {
        if (siniestroValues.ElVehiculoSufrioDanios) {
            setTienedanio({ label: "Si", value: "true" })
        }
    }, [])

    const onSubmit: SubmitHandler<any> = async (data) => {
        const dataFinal = {
            ...siniestroValues,
            relatoHechos: data.relatoHechos,
            dni: data.numDoc,
            ElVehiculoSufrioDanios: tieneDanios.value === "true",
            documentacion: [
                data.registro1,
                data.registro2,
                data.cedula1,
                data.cedula2
            ]
        }
        if (tieneDanios.value === "true") {
            dataFinal.daniosVehiculo = data.daniosVehiculo;
            dataFinal.archivos = [
                data.image1,
                data.image2,
                data.image3
            ]
        }
        setSiniestroValues({
            ...dataFinal
        });

        return nav("/siniestros/vehiculos/formulario/terceros")
    }


    return (
        <form onSubmit={handleSubmit(onSubmit)} className="row justify-content-center pt-4 pb-4">
            <div className="col-md-8">
                <Controller
                    name="relatoHechos"
                    control={control}
                    rules={{
                        required: "El relato de los hechos es obligatorio", validate: value =>
                            value?.trim().length > 0 || "El relato de los hechos es obligatorio"
                    }}
                    render={({ field, fieldState }) => (
                        <SegTextarea
                            label="Relato del hecho"
                            tooltip='Describí cómo sucedió el accidente, incluyendo todos los detalles relevantes; cómo fue la maniobra, si había semáforo, señales de tránsito, etc'
                            placeHolder="Escribí aquí el relato completo lo más detallado posible"
                            width={100}
                            name=""
                            className='mb-3'
                            onChange={(e) => {
                                field.onChange(e);
                                setValue("relatoHechos", e.target.value);
                                trigger("relatoHechos");
                            }}
                            value={field.value}
                            leyendaError={fieldState?.error?.message}
                            borderColor={fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}
                            focusBorderColor={fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}
                        />

                    )}
                />
                <div className='row'>
                    <div className='col-md-6'>
                        <label className='form-label d-flex align-items-center'>
                            DNI del conductor al momento del hecho
                            <SegTooltip 
                            placement={window.innerWidth > 668 ? "right" : "bottom"}
                            text={"Sólo números, sin puntos ni guiones (el campo solo admite números)"} />
                        </label>
                        <Controller
                            name="numDoc"
                            control={control}
                            rules={{
                                validate: {
                                    required: (value) => (!!value ? true : "Ingresá el Número"),
                                    onlyDigits: (value) =>
                                        /^\d*$/.test(value || "") || "Solo números (sin puntos ni guiones)",
                                    length: (value) =>
                                        /^\d{7,8}$/.test(value || "") || "DNI inválido (7 u 8 dígitos)"
                                }
                            }}
                            render={({ field, fieldState }) => (
                                <SegInput
                                    label=""
                                    name="setNumero"
                                    type="text"               
                                    inputMode="numeric"
                                    width={100}
                                    className="mb-3"
                                    placeHolder="Ej: 20354678"
                                    value={field.value || ""}
                                    onChange={(e) => {
                                        const digitsOnly = e.target.value.replace(/\D/g, "");
                                        field.onChange(digitsOnly);
                                        setValue("numDoc", digitsOnly, { shouldValidate: true });
                                        if (/\D/.test(e.target.value)) {
                                            // Si intentó meter no-dígitos, mostrás el error
                                            // (podés omitir esto si preferís solo sanitizar)
                                            // setError("numDoc", { type: "manual", message: "Solo números (sin puntos ni guiones)" });
                                        } else {
                                            // clearErrors("numDoc");
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        const allowed =
                                            ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End"].includes(e.key) ||
                                            // Permite dígitos del 0-9
                                            (/^\d$/.test(e.key) && !e.ctrlKey && !e.metaKey);

                                        if (!allowed) e.preventDefault();
                                    }}
                                    onPaste={(e) => {
                                        debugger
                                        const pasted = (e.clipboardData || (window as any).clipboardData).getData("text");
                                        if (!/^\d+$/.test(pasted)) {
                                            // Si el pegado trae puntos/guiones/letras, se bloquea y se muestra error
                                            e.preventDefault();
                                            setError("numDoc", {
                                                type: "manual",
                                                message: "Pegaste un formato inválido. Solo números (sin puntos ni guiones)."
                                            });
                                            return;
                                        }
                                        // Si es válido, dejás que pegue pero sanitizás igual por las dudas
                                        // (Como prevenimos el evento, podemos setear el valor manualmente)
                                        e.preventDefault();
                                        field.onChange(pasted);
                                        setValue("numDoc", pasted, { shouldValidate: true });
                                        clearErrors("numDoc");
                                    }}
                                    leyendaError={fieldState?.error?.message}
                                    borderColor={formState.errors?.numDoc ? "var(--bs-form-invalid-border-color)" : ""}
                                    focusBorderColor={formState.errors.numDoc ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}
                                />
                            )}
                        />
                    </div>
                    <div className='col-md-6'>
                        <FormProvider {...methods}>
                            <SegSelect
                                label='¿Tu vehículo sufrió daños?'
                                selected={tieneDanios}
                                setSelected={(opt) => {
                                    setTienedanio(opt)
                                    setValue("tieneDanios", opt.value === "true");
                                    if (opt.value === "false") {
                                        setValue("daniosVehiculo", "");
                                        setValue("image1", null);
                                        setValue("image2", null);
                                        setValue("image3", null);
                                    }
                                }}
                                name="tieneDanios"
                                className='mb-3'
                                openDefault={false}
                                options={[
                                    {
                                        label: "Si",
                                        value: "true"
                                    },
                                    {
                                        label: "No",
                                        value: "false"
                                    }
                                ]}
                                width={"100%"}
                                borderColor={formState.errors.tieneDanios ? "red" : ""}
                            />
                        </FormProvider>
                    </div>
                </div>
                {
                    tieneDanios.value === "true" &&
                    <>
                        <label className='form-label d-flex align-items-center'>
                            Describí los daños sufridos en el vehículo
                            <SegTooltip 
                             placement={window.innerWidth > 668 ? "right" : "bottom"}
                            text={"Indicá todos los detalles relevantes; ubicación, daño, parte/s involucradas. Ej: abolladura profunda en puerta derecha que impide apertura"} />
                        </label>
                        <Controller
                            name="daniosVehiculo"
                            control={control}
                            rules={{
                                required: "Los daños del vehículo son obligatorios",
                                validate: value =>
                                    value?.trim().length > 0 || "Complete la descripción de los daños del vehículo"
                            }}
                            render={({ field, fieldState }) => (
                                <SegTextarea
                                    label=""
                                    placeHolder="Escribí aquí los daños de tu vehículo lo más detallado posible"
                                    width={100}
                                    name=""
                                    className='mb-3'
                                    onChange={(e) => {
                                        field.onChange(e);
                                        setValue("daniosVehiculo", e.target.value);
                                        trigger("daniosVehiculo");
                                    }}
                                    value={field.value}
                                    leyendaError={fieldState?.error?.message}
                                    borderColor={fieldState?.error ? "var(--bs-form-invalid-border-color)" : ""}
                                    focusBorderColor={fieldState?.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}
                                />

                            )}
                        />
                        <label className='form-label d-flex align-items-center'>
                            Imágenes de los daños
                        </label>
                        <div className='row mb-4'>
                            <div className='col-md-4'>
                                <Controller
                                    name="image1"
                                    control={control}
                                    render={({ field }) => <SingleImageUpload
                                        {...field}
                                    />}
                                />
                            </div>
                            <div className='col-md-4'>
                                <Controller
                                    name="image2"
                                    control={control}
                                    render={({ field }) => <SingleImageUpload {...field} />}
                                />
                            </div>
                            <div className='col-md-4'>
                                <Controller
                                    name="image3"
                                    control={control}
                                    render={({ field }) => <SingleImageUpload {...field} />}
                                />
                            </div>
                        </div>
                    </>
                }


                <div className="mb-3">
                    <label className="form-label mb-4">Subí las imágenes solicitadas</label>

                    <div className='row mb-4'>
                        <div className='col-md-4'>
                            <label className="form-label">Licencia de conducir (frente)</label>
                            <Controller
                                name="registro1"
                                control={control}
                                rules={{
                                    required: "Esta imagen es requerida"
                                }}
                                render={({ field, fieldState }) =>
                                    <>
                                        <SingleImageUpload {...field} />
                                        {fieldState.error && (
                                            <div className="invalid-feedback d-block">
                                                {fieldState.error.message}
                                            </div>
                                        )}
                                    </>
                                }
                            />
                        </div>
                        <div className='col-md-4'>
                            <label className="form-label">Licencia de conducir (dorso)</label>
                            <Controller
                                name="registro2"
                                control={control}
                                rules={{
                                    required: "Esta imagen es requerida"
                                }}
                                render={({ field }) => <SingleImageUpload {...field} />}
                            />
                        </div>
                        <div className='col-md-4'>
                            <label className="form-label">Cédula Verde (frente)</label>
                            <Controller
                                name="cedula1"
                                control={control}
                                rules={{
                                    required: "Esta imagen es requerida"
                                }}
                                render={({ field }) => <SingleImageUpload {...field} />}
                            />
                        </div>
                        <div className='col-md-4 mt-2'>
                            <label className="form-label">Cédula Verde (dorso)</label>
                            <Controller
                                name="cedula2"
                                control={control}
                                rules={{
                                    required: "Esta imagen es requerida"
                                }}
                                render={({ field }) => <SingleImageUpload {...field} />}
                            />
                        </div>
                    </div>

                </div>

                <div className="text-center mt-4">
                    <SegButton
                        label={"Continuar"}
                        type="submit"
                        disabled={!formState.isValid}
                        bgColor={config.origen !== "SEGURARSE" ? config.colors.primary : undefined}
                        hoverBgColor={config.origen !== "SEGURARSE" ? config.colors.primary : undefined}
                        hoverBorderColor={config.origen !== "SEGURARSE" ? config.colors.accent : undefined}
                        hoverOpacity={config.origen !== "SEGURARSE"}
                    />
                </div>
            </div>
        </form>
    );
};